<div>
  <div class="tech-support-container background-fill-container">
    <div class="container">
      <div class="text-container col-sm-12 col-md-6 col-lg-6 col-xl-8">
        <div style="font-weight: 400; font-size: 16px; line-height: 28px; color: #3d515a">
          <adp-label [labelKey]="headerKey"></adp-label>
        </div>
        <div style="font-weight: 600; font-size: 24px; line-height: 33px; color: #13223c">
          <adp-label labelKey="TechSupport_subheading"></adp-label>
        </div>
        <button class="button-mobile-container" *ngIf="isChatAvailable" mat-flat-button color="accent" (click)="letsChat()">
          <adp-label labelKey="TechSupport_supportButtonLabel"></adp-label>
        </button>
        <div *ngIf="isAuthenticated" style="font-weight: 400; font-size: 16px; line-height: 28px; color: #3d515a">
          <adp-label labelKey="TechSupport_supportNumber"></adp-label>
        </div>
        <div *ngIf="!isAuthenticated" style="font-weight: 400; font-size: 16px; line-height: 28px; color: #3d515a">
          <adp-label labelKey="TechSupport_SupportNumber_NoAuth"></adp-label>
        </div>
        <div style="font-weight: 400; font-size: 14px; line-height: 24px; color: #68758b">
          <adp-label labelKey="TechSupport_supportHours"></adp-label>
        </div>
      </div>
      <div class="image-container col-sm-12 col-md-6 col-lg-6 col-xl-8">
        <adp-image class="profile-img" aria-hidden="true" imageKey="Global_TechSupport_Image"></adp-image>
      </div>
    </div>
  </div>
</div>
